import { BASE_URL } from "@/env";
import axios, { Method } from "axios";

const isLogEnabled = true;

const instance = axios.create({
  baseURL: `${BASE_URL}`,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  maxContentLength: 5 * 1000 * 1000,
});

instance.interceptors.request.use(
  (config) => {
    if (isLogEnabled)
      console.log(
        "Network Request:",
        `${config.baseURL}${config.url}`,
        config.method
      );
    return config;
  },
  async (error) => {
    if (isLogEnabled) console.error("Network Request:", error);
    throw error;
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (isLogEnabled) console.error("Network Response:", error);
    throw error && error.response && error.response.data;
  }
);

export type NetworkResponse<T extends object | null> = {
  readonly code: string;
  readonly data?: T;
};

export interface NetworkRequest<T extends object | null> {
  url: string;
  method: Method;
  data?: T;
  params?: object;
}

export interface NetworkAuthRequest<T extends object | null>
  extends NetworkRequest<T> {
  headers?: { Authorization: string };
}

export async function publicRequest<
  T extends object | null,
  R extends object | null
>(request: NetworkRequest<T>): Promise<NetworkResponse<R>> {
  const { data } = await instance.request<NetworkResponse<R>>(request);
  return data;
}

export async function protectedRequest<
  T extends object | null,
  R extends object | null
>(
  request: NetworkRequest<T>,
  callback: () => void
): Promise<NetworkResponse<R>> {
  try {
    const token = await localStorage.getItem("access_token");

    (request as NetworkAuthRequest<T>).headers = {
      Authorization: `${token}`,
    };

    const { data } = await instance.request<NetworkResponse<R>>(request);
    return data;
  } catch (e: any) {
    if (e.response && e.response.status === "401") {
      await localStorage.removeItem("access_token");
      callback();
    }
    throw e;
  }
}
